module.exports = __webpack_public_path__ + "img/addtocart-sucess.70ec33e1.svg";